// External
import {useEffect, useMemo, useState, useRef} from "react";
import clsx from "clsx";
import {components} from 'react-select';
import {Disclosure} from '@headlessui/react'
import {AnimatePresence, motion} from "framer-motion";
import {AdjustmentsHorizontalIcon, ChevronRightIcon, Squares2X2Icon, Bars3Icon} from "@heroicons/react/20/solid";

// Internal Components
import Checkbox from "@/components/Checkbox";
import Container from "@/components/Container";
import PillBadge from "@/components/PillBadge";
import EventItemsGrid from "@/components/EventItemsGrid";
import TypeaheadInput from "@/components/TypeaheadInput";

// Internal data
import {eventData} from "../../json/events2";

// Utils
import {getStates, scrollTop, slugify} from "@/lib/util";
import {getAllParkCodesForState, getEventsAndSortByDate, getStateAbbr} from "@/lib/data"
import {getAllEvents, getParkNameSelectOptions} from "@/lib/data";

// Styles
import {filterSelectStyles} from "@/lib/styles";
import IconTooltip from "@/components/IconTooltip";
import {useRouter} from "next/router";
import Head from "next/head";

function FilterItem({ children }) {
    return (
        <div className="flex uppercase text-sm font-black py-4 pl-4">
            {children}
        </div>
    )
}

function FilterItemButton({ title, items, type, onChange, className, panelClassName, filters, filterType, includeTypeahead, typeaheadOptions, typeaheadPlaceholder, handleTypeaheadOnChange }) {
    const refPanel = useRef()

    function onInputChange(selectedOptions) {
        console.log('change')
        console.log('selectedOptions',selectedOptions)
    }

    const menuListStyles = (base, state) => {
        console.log('menuList styles', base);
        return base;
    };

    const menuHeaderStyle = {
        padding: '8px 12px',
        background: 'green',
        color: 'white',
    };

    const CustomMenuList = ({ props, children }) => {

        console.log(props)
        return (
            <components.MenuList {...props}>
                <div style={menuHeaderStyle}>Custom Menu List</div>
                {children}
            </components.MenuList>
        );
    }

    return (
        <Disclosure>
            {({ open }) => (
            <div className={clsx("border-y border-beige-100/50", className)}>
                <Disclosure.Button className="flex justify-between items-center w-full tracking-wide text-xs py-4 px-4">
                    {title} <ChevronRightIcon width={18} className={clsx('ml-4 pointer-events-none ui-open:rotate-90 ui-open:transform')} />
                </Disclosure.Button>
                <Disclosure.Panel className={clsx(`pb-5 pt-2 px-4 max-h-[200px] ${filters.length > 0 || open ? 'opacity-100' : ''} overflow-scroll`, panelClassName)} id={`${slugify(title)}`} ref={refPanel}>
                    <AnimatePresence>
                        <motion.ul
                            initial={{ opacity: 0, y: -5 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -5 }}
                            transition={{ bounce: 0, duration: 0.2 }}
                            className="relative w-full flex flex-col gap-3"
                        >
                            {includeTypeahead &&
                                <TypeaheadInput
                                    options={typeaheadOptions}
                                    // value={states.filter((option) => option.value === selectedStateValue)}
                                    onChange={handleTypeaheadOnChange}
                                    onInputChange={onInputChange}
                                    isClearable={true}
                                    placeholder={typeaheadPlaceholder}
                                    className={`w-full`}
                                    styles={filterSelectStyles}
                                    components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null, MenuList: CustomMenuList }}
                                    noOptionsMessage={() => null}
                                    // menuPortalTarget={selectRef.current}
                                />
                            }
                            {type === 'check' && (
                                items.map((item) => <Checkbox key={item.label} label={item.label} value={item.value} tag="li" className="flex" onChange={onChange} filters={filters} filterType={filterType} />)
                            )}
                        </motion.ul>
                    </AnimatePresence>
                </Disclosure.Panel>
            </div>
            )}
        </Disclosure>
    )
}

const getQueriesFromAsPath = (asPath) => {
    const queryString = asPath.split('?')[1];
    const searchParams = new URLSearchParams(queryString);

    const pageParam = searchParams.get('page');
    const page = pageParam === null ? 1 : Number(pageParam);

    const park = searchParams.get('park');
    const type = searchParams.get('event-type');
    const state = searchParams.get('state');

    return { park, type, state, page };
};

export default function Events({ events }) {
    const router = useRouter()
    const { asPath, isReady } = router;
    const { page, searchQuery } = getQueriesFromAsPath(asPath);

   // events = getEventsAndSortByDate(events)

    // Create array with all event types for filter bar.
    let eventTypes = []
    let eventObjects = Object.values(events)
    events && eventObjects.map((event) => {
        if (event.types && event.types.length) {
            event.types.map((type) => eventTypes.push({
                'value': slugify(type),
                'label': type
            }))
        }
    })
    const types = [...new Map(eventTypes.map(item => [item['value'], item])).values()];

    // Set pagination and page related variables.
    let PageSize = 12
    let lastPage = Math.round(events.length / PageSize)

    // Get state and park name options.
    const states = getStates()
    const parkNameOptions = getParkNameSelectOptions()

    const [filteredEvents, setFilteredEvents] = useState([])
    const [filterTagsType, setFilterTagsType] = useState([])
    const [filterTagsState, setFilterTagsState] = useState([])
    const [filterTagsPark, setFilterTagsPark] = useState([])

    const [isListView, setIsListView] = useState(false)
    const [isLoading, setIsLoading] = useState(null);
    const [noResults, setNoResults] = useState(false);
    const [currentPage, setCurrentPage] = useState(() => page && page < lastPage ? page : 1);


    // @todo: Add query params for each filter type.
    // const [filterTagsType, setFilterTagsType] = useState(() => {
    //     let eventSlug = getQueriesFromAsPath(asPath, 'event-type').type
    //     let eventTypes = types.filter((type) => type.value === eventSlug)
    //     //console.log([eventTypes[0]?.label])
    //     return eventTypes[0]?.label ? [eventTypes[0].label] : []
    // })
    // const [filterTagsState, setFilterTagsState] = useState(() => {
    //     let stateSlug = getQueriesFromAsPath(asPath, 'state').state
    //     let stateFullName = states.filter((state) => slugify(state.label) === stateSlug)
    //     //console.log([stateFullName[0]?.label])
    //     return stateFullName[0]?.label ? [stateFullName[0].label] : []
    // })
    // const [filterTagsPark, setFilterTagsPark] = useState(() => {
    //     let parkSlug = getQueriesFromAsPath(asPath, 'park').park
    //     let parkFullName = parks.filter((park) => park.slug === parkSlug)
    //     return parkFullName[0]?.fullName ? [parkFullName[0]?.fullName] : []
    // })

    useEffect(() => {
        // sync asPath with state (state feedback look)
        const { page } = getQueriesFromAsPath(asPath);
        if (page > lastPage) {
            router.push({
                pathname: router.pathname,
                query: {}
            }, undefined, { shallow: true })
        }
        setCurrentPage(page);
    }, [asPath]);


    // On pagination page change, update current page and scroll to the top of the events grid.
    function onPageChange(page) {
        setCurrentPage(page)
        scrollTop('#events-grid')
    }

    // useMemo hook to subscribe to current page and update first/ last index and get appropriate events.
    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        return filteredEvents.slice(firstPageIndex, lastPageIndex);
    }, [PageSize, currentPage, filteredEvents]);


    // Type filter on change event, set current page to 1 and update filter state.
    function handleFilterChange(e, setState, filterTagType, queryParam) {
        e.preventDefault()
        setIsLoading(true)
        let pillValue = e.target.dataset.item
        let filterValue = pillValue ? pillValue : document.querySelector(`#${e.target.name}-label`).innerHTML
        setCurrentPage(1)
        if (e.target.checked) {
            setState([...filterTagType, filterValue])
        } else {
            setState(
                filterTagType.filter((filter) => filter !== filterValue)
            )
        }

        console.log(filterValue)
        // Set query parameters.
        // if (queryParam === 'park') {
        //     router.replace({
        //         pathname: router.pathname,
        //         query: {
        //             ...router.query,
        //             park: `${slugify(filterValue)}`
        //         }
        //     }, undefined, { shallow: true })
        // } else if (queryParam === 'event-type') {
        //     router.replace({
        //         pathname: router.pathname,
        //         query: {
        //             ...router.query,
        //             'event-type': `${slugify(filterValue)}`
        //         }
        //     }, undefined, { shallow: true })
        // } else if (queryParam === 'state') {
        //     router.replace({
        //         pathname: router.pathname,
        //         query: {
        //             ...router.query,
        //             state: `${slugify(filterValue)}`
        //         }
        //     }, undefined, { shallow: true })
        // }

        setTimeout(() => setIsLoading(false), 200)
    }

    // Filter pill click handler, update filter tags.
    function onFilterTypePillClick(e, setState, filterTagType) {
        setState(
            filterTagsType.filter((filterTag) => filterTag !== e.target.dataset.item)
        )
        handleFilterChange(e, setState, filterTagType)
    }

    // Clear all filters.
    function onClearFilters() {
        setIsLoading(true)
        setFilterTagsState([])
        setFilteredEvents([])
        setFilterTagsType([])
        router.push({
            pathname: router.pathname,
            query: {}
        }, undefined, { shallow: true })
        setTimeout(() => setIsLoading(false), 300)
    }

    // Apply all active filters and set filtered events.
    useEffect(() => {
        const filterEventsByEventType = (array) => {
            return array.filter((event) =>
                filterTagsType.length > 0 ? filterTagsType.every((filterTag) =>
                    event.types?.map((value) => value).includes(filterTag)
                ) : array
            )
        }

        const filterEventsByState = (array) => {
            return array.filter((event) =>
                filterTagsState.length > 0 ? filterTagsState.some((filterTag) => {
                    let stateAbbr = getStateAbbr(filterTag)
                    let parkCodes = getAllParkCodesForState(stateAbbr)
                    return parkCodes.includes(event.sitecode)
                    }
                ) : array
            )
        }

        const filterEventsByPark = (array) => {
            return array.filter((event) =>
                filterTagsPark.length > 0 ? filterTagsPark.some((filterTag) => event.parkFullName === filterTag
                ) : array
            )
        }

        let result = events;
        result = filterEventsByPark(result);
        result = filterEventsByEventType(result);
        result = filterEventsByState(result);
       // result.sort((a, z) => new Date(a.datestart) - new Date(z.datestart))
        setFilteredEvents(result);
    }, [filterTagsType, filterTagsState, filterTagsPark]);

    // No results messaging.
    useEffect(() => {
        if (filteredEvents.length === 0) {
            setNoResults(true)
        } else {
            setNoResults(false)
        }
    }, [filteredEvents])

    // Force grid view on mobile.
    useEffect(() => {
        function handleResize() {
            if (window.innerWidth < 768) {
                setIsListView(false)
            }
        }
        window.addEventListener('resize', handleResize)
    }, [])

    return (
        <>
            <Head>
                <title>Events - Explore National Parks</title>
            </Head>
            <main>
                <Container>
                    <div className="lg:grid lg:grid-cols-[250px,auto] lg:gap-8">
                        <div className="z-0 bg-white border border-beige-100/50 rounded">
                            <div className="top-0 left-0">
                                <FilterItem>
                                    <AdjustmentsHorizontalIcon width={18} className="mr-4"/> Filter & Sort
                                </FilterItem>
                                <FilterItemButton
                                    title="National Park"
                                    items={parkNameOptions}
                                    type={"check"}
                                    // includeTypeahead
                                    // typeaheadOptions={parkNameOptions}
                                    // typeaheadPlaceholder={'Search'}
                                    panelClassName={'max-h-[400px]'}
                                    onChange={(e) => handleFilterChange(e, setFilterTagsPark, filterTagsPark, 'park')}
                                    filters={filterTagsPark}
                                    filterType={'park'}/>
                                <FilterItemButton
                                    title="Event Type"
                                    items={types}
                                    type="check"
                                    onChange={(e) => handleFilterChange(e, setFilterTagsType, filterTagsType, 'event-type')}
                                    filters={filterTagsType}
                                    filterType={'event'}
                                    className="border-y-0"/>
                                <FilterItemButton
                                    title="State"
                                    items={states}
                                    type={"check"}
                                    onChange={(e) => handleFilterChange(e, setFilterTagsState, filterTagsState, 'state')}
                                    filters={filterTagsState}
                                    filterType={'state'}
                                    className="border-b-0 lg:border-b"
                                />
                                {/*<FilterItemButton title="Dates" />*/}
                            </div>
                        </div>

                        <div className="mt-5">
                            <h1 className="sr-only">Events</h1>
                            <div className="flex justify-between">
                                <p><strong>{filteredEvents.length}</strong> events</p>
                                <div className="items-center hidden md:flex">
                                    <IconTooltip name="List view" tooltipClassNames={`border shadow border-0 bg-white`}
                                                 onClick={(e) => setIsListView(true)}>
                                        <Bars3Icon width={25}
                                                   className={clsx('pointer-events-none p-1 rounded-sm', isListView ? 'bg-beige-100/60' : '')}/>
                                    </IconTooltip>
                                    <IconTooltip name="Grid view" tooltipClassNames={`border shadow border-0 bg-white`}
                                                 onClick={(e) => setIsListView(false)}>
                                        <Squares2X2Icon width={25}
                                                        className={clsx('ml-3 pointer-events-none p-1 rounded-sm', isListView ? '' : 'bg-beige-100/60')}/>
                                    </IconTooltip>
                                </div>
                            </div>
                            {filterTagsType.length > 0 || filterTagsState.length > 0 || filterTagsPark.length > 0 ?
                                <nav className="mt-4">
                                    <AnimatePresence>
                                        <motion.ul
                                            initial={{opacity: 0, y: -5}}
                                            animate={{opacity: 1, y: 0}}
                                            exit={{opacity: 0, y: -5}}
                                            transition={{bounce: 0, duration: 0.2}}
                                            className="relative w-full flex flex-wrap flex-col gap-3"
                                        >
                                            <ul className="flex flex-wrap items-center gap-2">
                                                {filterTagsPark.map((item) => <PillBadge key={item} item={item}
                                                                                         onClick={(e) => onFilterTypePillClick(e, setFilterTagsPark, filterTagsPark)}/>)}
                                                {filterTagsType.map((item) => <PillBadge key={item} item={item}
                                                                                         onClick={(e) => onFilterTypePillClick(e, setFilterTagsType, filterTagsType)}/>)}
                                                {filterTagsState.map((item) => <PillBadge key={item} item={item}
                                                                                          onClick={(e) => onFilterTypePillClick(e, setFilterTagsState, filterTagsState)}/>)}
                                                {/*<li><button onClick={onClearFilters} className="text-xs ml-2">Clear all filters</button></li>*/}
                                            </ul>
                                        </motion.ul>
                                    </AnimatePresence>
                                </nav>
                                : null}
                            {noResults &&
                                <motion.p
                                    initial={{opacity: 0}}
                                    animate={{opacity: 1}}
                                    transition={{delay: 0.3}}
                                >
                                    <p className="mt-4 text-sm">No events for the selected filters. Try adjusting your
                                        filters.</p>
                                </motion.p>
                            }

                            <EventItemsGrid
                                events={currentData}
                                gridClassNames={`grid gap-6 my-5 ${isListView ? 'grid-cols-1' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'}`}
                                isListView={isListView}
                                isLoading={isLoading}
                                currentPage={currentPage}
                                totalCount={filteredEvents.length}
                                pageSize={PageSize}
                                onPageChange={onPageChange}
                                displayLoadMore
                                showPagination/>
                        </div>
                    </div>
                </Container>
            </main>
        </>
    )
}

export async function getStaticProps() {
    //const events = await getAllEvents()
    let events = Object.values(eventData);
    return {
        props: {events}
    }
}